import { status } from '../../config.ts'
import { validateCode } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'POST',
    path: `/login_check`,
    reply: async () => {
      await wait()
      return [status.ok, { message: 'Verification code sent to your email.' }]
    }
  },
  {
    method: 'POST',
    path: `/validate-code`,
    reply: async () => {
      await wait()
      return [status.ok, validateCode]
    }
  },
  {
    method: 'POST',
    path: `/logout`,
    reply: async () => {
      await wait()
      return [status.ok, { message: 'Logged out successfully.' }]
    }
  }
]
